import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock } from '@react-icons/all-files/fa/FaLock';

export interface PermissionDeniedScreenProps {
  /** Códigos de autoridad que faltan (se muestran entre comillas). */
  requiredAuthorities: string[];
  title?: string;
  backTo?: string;
  backLabel?: string;
}

function permissionMessage(requiredAuthorities: string[]): string {
  const quoted = requiredAuthorities.map(p => `"${p}"`);
  if (quoted.length === 1) return `Se requiere el permiso ${quoted[0]}.`;
  return `Se requiere al menos uno de los siguientes permisos: ${quoted.join(' o ')}.`;
}

export default function PermissionDeniedScreen({
  requiredAuthorities,
  title = 'Acceso no autorizado',
  backTo = '/configuracion',
  backLabel = 'Volver',
}: PermissionDeniedScreenProps) {
  return (
    <div style={s.shell} role="alert">
      <div style={s.card}>
        <figure style={s.lockFigure} aria-hidden>
          <span style={s.lockCircle}>
            <FaLock style={s.lockIcon} />
          </span>
        </figure>
        <h1 style={s.heading}>{title}</h1>
        <p style={s.message}>{permissionMessage(requiredAuthorities)}</p>
        <Link to={backTo} style={s.linkBtn}>
          {backLabel}
        </Link>
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  shell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'min(70vh, 560px)',
    padding: 24,
  },
  card: {
    background: '#fff',
    borderRadius: 14,
    border: '1px solid #e2e8f0',
    boxShadow: '0 8px 32px rgba(15, 23, 42, 0.08)',
    maxWidth: 440,
    width: '100%',
    padding: '32px 28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 16,
  },
  lockFigure: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
  },
  lockCircle: {
    width: 96,
    height: 96,
    borderRadius: '50%',
    background: 'linear-gradient(145deg, #e2e8f0 0%, #f1f5f9 100%)',
    border: '1px solid #cbd5e1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.8)',
  },
  lockIcon: {
    width: 48,
    height: 48,
    color: '#475569',
  },
  heading: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    color: '#0f172a',
    lineHeight: 1.35,
  },
  message: {
    margin: 0,
    fontSize: 15,
    lineHeight: 1.5,
    color: '#475569',
    wordBreak: 'break-word',
  },
  linkBtn: {
    marginTop: 4,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 20px',
    borderRadius: 8,
    background: '#3b82f6',
    color: '#fff',
    fontWeight: 600,
    fontSize: 14,
    textDecoration: 'none',
  },
};
